import {
  CompanyIndustrySkeleton,
  CompanyJobCountSkeleton,
  CompanyTitleSkeleton,
  ImageSkeleton,
} from "./styles";

export default function CompanyCardSkeleton({ className }) {
  return (
    <div className={className}>
      <ImageSkeleton variant="rectangular" />
      <CompanyTitleSkeleton variant="text" />
      <CompanyIndustrySkeleton variant="text" />
      <CompanyJobCountSkeleton variant="text" />
    </div>
  );
}
